import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormInputDropdown from '../../common/Forms/FormDropdown';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { Auth } from 'aws-amplify';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FormContentTitle, FormHeading, FullDivider } from '../../ui/styled';
import BackIcon from '../../common/Back/BackIcon';
import PageHeading from '../../common/Heading/PageHeading';
import FormInputMultiCheckbox from '../../common/Forms/FormCheckbox';
import FormInputText from '../../common/Forms/FormTextField';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import CBPInvoicesList from '../CBPDataGrids/CBPInvoicesList';
import CBPCaseManagerList from '../CBPDataGrids/CBPCaseManager/CBPCaseManagerList';
import CbpRates from '../CBPDataGrids/CbpRates/CbpRates';
import {
  stopYesNoIdOptions,
  formDateFormat,
  CBP_FORM_PUT_AND_POST_URL,
  fieldRequired,
} from '../../../constants';
import ProgressBar from '../../common/ProgressBar/ProgressBar';
import {
  setCboName,
  setOrganization,
  setAcceptsCCCMS,
  setCbpCode,
  setFirstReferralContact,
  setSecondReferralContact,
  setLastVerWk,
  setCup,
  setModality,
  setEnhancedServicesRate,
  setSTOPBeds,
  setVerificationContact,
  setVerificationContact2,
  setSlecupNALtrDate,
  setCupMaxBeds,
  setGender,
  setBlanketPurchaseAgreementDedCapSap,
  setMaxAdmits,
  setWcVeificationContact1,
  setWcVeificationContact2,
  setADPEffDate,
  setADPLicCert,
  setAccepts290s,
  setFoodProvided,
  setCalOMSContact,
  setWcCalOMSContacts1,
  setWcCalOMSContact2,
  setADPExpDate,
  setADPMaxBeds,
  setDataDepartmentComment,
  setSap,
  setBPADedCap,
  setInactive,
  setFlagged,
  setVerLock,
  setCupNA,
  setCurrentFYRateSheetReceivedandVerified,
  setOverorUnderDARSApprovedCountyRate,
  setContractComplianceStatusNote,
  setLowIntensity,
  setMedIntensity,
  setHighIntensity,
} from '../../../redux/cbp/cbpForm/cbpFormSlice';
import FormSuccess from '../../common/Forms/FormSuccess';
import {
  ButtonWrapper,
  CancelButton,
  SaveButton,
} from '../../Episode/Episode.Styled';
import { postStopApi, setStopApi } from '../../../services/StopApi/StopApi';
import CancelPopUp from '../../common/CancelPopUp/CancelPopUp';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { getCbpFullName } from '../cbpUtils';

const schema = yup.object().shape({
  organization: yup.string().required(fieldRequired),
  modality: yup.string().required(fieldRequired),
  gender: yup.string().required(fieldRequired),
  dataDepartmentComment: yup
    .string().nullable()
    .max(800, 'This field should not exceed 800 characters'),
  contractComplianceStatusNote: yup
    .string().nullable()
    .max(800, 'This field should not exceed 800 characters'),
});

const CbpForm = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [expanded, setExpanded] = useState();
  const [formLoading, setFormLoading] = useState(true);
  const [formSuccess, setFormSuccess] = useState(false);
  const [cancelPopUp, setCancelPopUp] = useState(false);
  const [isNewCBPForm, setIsNewCBPForm] = useState(false);

  const cbpForm = useSelector((state) => state.cbpForm);
  const cbpFormReferenceData = useSelector(
    (state) => state.cbpFormReferenceData
  );
//console.log(cbpFormReferenceData?.modalities);
  const isCBOTrueOrganization = cbpFormReferenceData?.organizations.filter(
    (item) => (item.isCBO === true ? item.orgKey : '')
  );
  const isSAPTrueOrganization = cbpFormReferenceData?.organizations.filter(
    (item) => (item.isSAP === true ? item.orgKey : '')
  );
  const isFirstReferralContact = cbpFormReferenceData?.contacts.filter((item) =>
    item.isFirstReferralContact === true ? item.value : ''
  );
  const isSecondReferralContact = cbpFormReferenceData?.contacts.filter(
    (item) => (item.isSecondReferralContact === true ? item.value : '')
  );
  const isVerificationContact = cbpFormReferenceData?.contacts.filter((item) =>
    item.isVerificationContact === true ? item.value : ''
  );
  const isVerificationContact2 = cbpFormReferenceData?.contacts.filter((item) =>
    item.isVerificationContact2 === true ? item.value : ''
  );
  const isWCVeificationContact1 = cbpFormReferenceData?.contacts.filter(
    (item) => (item.isWCVeificationContact1 === true ? item.value : '')
  );
  const isWCVeificationContact2 = cbpFormReferenceData?.contacts.filter(
    (item) => (item.isWCVeificationContact2 === true ? item.value : '')
  );
  const isCalOMSContact = cbpFormReferenceData?.contacts.filter((item) =>
    item.isCalOMSContact === true ? item.value : ''
  );
  const isWCCalOMSContacts1 = cbpFormReferenceData?.contacts.filter((item) =>
    item.isWCCalOMSContacts1 === true ? item.value : ''
  );
  const isWCCalOMSContact2 = cbpFormReferenceData?.contacts.filter((item) =>
    item.isWCCalOMSContact2 === true ? item.value : ''
  );

  const {
    cboID,
    cboName,
    organization,
    acceptsCCCMS,
    cbpCode,
    firstReferralContact,
    secondReferralContact,
    lastVerWk,
    cup,
    enhancedServicesRate,
    modality,
    sTOPBeds,
    verificationContact,
    verificationContact2,
    slecupNALtrDate,
    cupMaxBeds,
    gender,
    blanketPurchaseAgreementDedCapSap,
    maxAdmits,
    wcVeificationContact1,
    wcVeificationContact2,
    aDPEffDate,
    aDPLicCert,
    accepts290s,
    foodProvided,
    calOMSContact,
    wcCalOMSContacts1,
    wcCalOMSContact2,
    aDPExpDate,
    ADPMaxBeds,
    dataDepartmentComment,
    sap,
    bPADedCap,
    inactive,
    flagged,
    verLock,
    cupNA,
    currentFYRateSheetReceivedandVerified,
    overorUnderDARSApprovedCountyRate,
    contractComplianceStatusNote,
    lowIntensity,
    medIntensity,
    highIntensity,
  } = cbpForm;

  const defaultValue = {
    cboID: cboID,
    cboName: cboName,
    organization: organization,
    acceptsCCCMS: acceptsCCCMS,
    cbpCode: cbpCode,
    firstReferralContact: firstReferralContact,
    secondReferralContact: secondReferralContact,
    lastVerWk: lastVerWk,
    cup: cup,
    modality: modality,
    enhancedServicesRate: enhancedServicesRate,
    sTOPBeds: sTOPBeds,
    verificationContact: verificationContact,
    verificationContact2: verificationContact2,
    slecupNALtrDate: moment(slecupNALtrDate).format(formDateFormat),
    cupMaxBeds: cupMaxBeds,
    gender: gender,
    blanketPurchaseAgreementDedCapSap: blanketPurchaseAgreementDedCapSap,
    maxAdmits: maxAdmits,
    wcVeificationContact1: wcVeificationContact1,
    wcVeificationContact2: wcVeificationContact2,
    aDPEffDate: moment(aDPEffDate).format(formDateFormat),
    aDPLicCert: aDPLicCert,
    accepts290s: accepts290s,
    foodProvided: foodProvided,
    calOMSContact: calOMSContact,
    wcCalOMSContacts1: wcCalOMSContacts1,
    wcCalOMSContact2: wcCalOMSContact2,
    aDPExpDate: moment(aDPExpDate).format(formDateFormat),
    ADPMaxBeds: ADPMaxBeds,
    dataDepartmentComment: dataDepartmentComment,
    sap: sap,
    bPADedCap: bPADedCap,
    inactive: inactive,
    flagged: flagged,
    verLock: verLock,
    cupNA: cupNA,
    currentFYRateSheetReceivedandVerified:
      currentFYRateSheetReceivedandVerified,
    overorUnderDARSApprovedCountyRate: overorUnderDARSApprovedCountyRate,
    contractComplianceStatusNote: contractComplianceStatusNote,
    lowIntensity: lowIntensity,
    medIntensity: medIntensity,
    highIntensity: highIntensity,
  };

  const cbpFullName = getCbpFullName(
    cbpFormReferenceData,
    organization,
    modality,
    gender,
    sap,
    accepts290s,
    acceptsCCCMS,
    bPADedCap,
    lowIntensity,
    medIntensity,
    highIntensity,
    inactive
  );

  useEffect(() => {
    dispatch(setCboName(cbpFullName));
  }, [cbpFullName]);

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(schema),
  });
  const { handleSubmit, reset, control, setValue, watch, register, formState } =
    useFunction;
  const { isValid, dirtyFields, errors } = formState;

  useEffect(() => {
    getUser().then((userData) => setUser(userData));
  }, []);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  useEffect(() => {
    setTimeout(() => {
      setFormLoading(false);
    }, 500);
  }, [formLoading]);

  useEffect(() => {
    reset(defaultValue);
  }, [
    defaultValue.cboID,
    defaultValue.cboName,
    defaultValue.organization,
    defaultValue.acceptsCCCMS,
    defaultValue.cbpCode,
    defaultValue.firstReferralContact,
    defaultValue.secondReferralContact,
    defaultValue.lastVerWk,
    defaultValue.cup,
    defaultValue.modality,
    defaultValue.enhancedServicesRate,
    defaultValue.sTOPBeds,
    defaultValue.verificationContact,
    defaultValue.verificationContact2,
    defaultValue.slecupNALtrDate,
    defaultValue.cupMaxBeds,
    defaultValue.gender,
    defaultValue.blanketPurchaseAgreementDedCapSap,
    defaultValue.maxAdmits,
    defaultValue.wcVeificationContact1,
    defaultValue.wcVeificationContact2,
    defaultValue.aDPEffDate,
    defaultValue.aDPLicCert,
    defaultValue.accepts290s,
    defaultValue.foodProvided,
    defaultValue.calOMSContact,
    defaultValue.wcCalOMSContacts1,
    defaultValue.wcCalOMSContact2,
    defaultValue.aDPExpDate,
    defaultValue.ADPMaxBeds,
    defaultValue.dataDepartmentComment,
    defaultValue.sap,
    defaultValue.bPADedCap,
    defaultValue.inactive,
    defaultValue.flagged,
    defaultValue.verLock,
    defaultValue.cupNA,
    defaultValue.currentFYRateSheetReceivedandVerified,
    defaultValue.overorUnderDARSApprovedCountyRate,
    defaultValue.contractComplianceStatusNote,
    defaultValue.lowIntensity,
    defaultValue.medIntensity,
    defaultValue.highIntensity,
  ]);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const onSubmit = () => {
    const url = `${CBP_FORM_PUT_AND_POST_URL}`;
    const authorization = user?.signInUserSession.accessToken.jwtToken;
    if (cbpForm?.newCbpForm === true) {
      const payload = {
        organization: organization ? organization : null,
        modality: modality ? modality : null,
        gender: gender ? gender : null,
        sap: sap ? sap : false,
        accepts290s: accepts290s === '' ? null : accepts290s,
        acceptsCCCMS: acceptsCCCMS === '' ? null : acceptsCCCMS,
        enhancedServicesRate:
          enhancedServicesRate === '' ? null : enhancedServicesRate,
        inactive: inactive ? inactive : false,
        bPADedCap: bPADedCap ? bPADedCap : false,
        cbpCode: cbpCode ? cbpCode : null,
        firstReferralContact: firstReferralContact
          ? firstReferralContact
          : null,
        secondReferralContact: secondReferralContact
          ? secondReferralContact
          : null,
        verificationContact: verificationContact ? verificationContact : null,
        verificationContact2: verificationContact2
          ? verificationContact2
          : null,
        wcVeificationContact1: wcVeificationContact1
          ? wcVeificationContact1
          : null,
        wcVeificationContact2: wcVeificationContact2
          ? wcVeificationContact2
          : null,
        calOMSContact: calOMSContact ? calOMSContact : null,
        wcCalOMSContacts1: wcCalOMSContacts1 ? wcCalOMSContacts1 : null,
        wcCalOMSContact2: wcCalOMSContact2 ? wcCalOMSContact2 : null,
        verLock: verLock ? verLock : false,
        lastVerWk: lastVerWk ? lastVerWk : null,
        flagged: flagged ? flagged : false,
        lowIntensity: lowIntensity ? lowIntensity : false,
        medIntensity: medIntensity ? medIntensity : false,
        highIntensity: highIntensity ? highIntensity : false,
        maxAdmits: maxAdmits ? maxAdmits : null,
        blanketPurchaseAgreementDedCapSap: blanketPurchaseAgreementDedCapSap
          ? blanketPurchaseAgreementDedCapSap
          : null,
        currentFYRateSheetReceivedandVerified:
          currentFYRateSheetReceivedandVerified
            ? currentFYRateSheetReceivedandVerified
            : false,
        dataDepartmentComment: dataDepartmentComment
          ? dataDepartmentComment
          : null,
        foodProvided: foodProvided === '' ? null : foodProvided,
        cup: cup ? cup : null,
        cupMaxBeds: cupMaxBeds ? cupMaxBeds : null,
        cupNA: cupNA ? cupNA : false,
        slecupNALtrDate: slecupNALtrDate ? slecupNALtrDate : null,
        aDPLicCert: aDPLicCert ? aDPLicCert : null,
        aDPEffDate: aDPEffDate ? aDPEffDate : null,
        aDPExpDate: aDPExpDate ? aDPExpDate : null,
        ADPMaxBeds: ADPMaxBeds ? ADPMaxBeds : null,
        sTOPBeds: sTOPBeds ? sTOPBeds : null,
        overorUnderDARSApprovedCountyRate: overorUnderDARSApprovedCountyRate
          ? overorUnderDARSApprovedCountyRate
          : false,
        contractComplianceStatusNote: contractComplianceStatusNote
          ? contractComplianceStatusNote
          : null,
      };
      postStopApi({ url, payload, authorization }).then((response) => {
        console.log(response);
        if (response.succeeded === true) {
          setFormSuccess(true);
          setIsNewCBPForm(true);
          navigate(-1);
        }
      }).catch((e) => alert(e));
    } else {
      const payload = {
        cboID: cboID,
        organization: organization,
        modality: modality,
        gender: gender,
        sap: sap,
        accepts290s: accepts290s,
        acceptsCCCMS: acceptsCCCMS,
        enhancedServicesRate: enhancedServicesRate,
        inactive: inactive,
        bPADedCap: bPADedCap,
        cbpCode: cbpCode,
        firstReferralContact: firstReferralContact,
        secondReferralContact: secondReferralContact,
        verificationContact: verificationContact,
        verificationContact2: verificationContact2,
        wcVeificationContact1: wcVeificationContact1,
        wcVeificationContact2: wcVeificationContact2,
        calOMSContact: calOMSContact,
        wcCalOMSContacts1: wcCalOMSContacts1,
        wcCalOMSContact2: wcCalOMSContact2,
        verLock: verLock,
        lastVerWk: lastVerWk,
        flagged: flagged,
        lowIntensity: lowIntensity,
        medIntensity: medIntensity,
        highIntensity: highIntensity,
        maxAdmits: maxAdmits,
        blanketPurchaseAgreementDedCapSap: blanketPurchaseAgreementDedCapSap,
        currentFYRateSheetReceivedandVerified:
          currentFYRateSheetReceivedandVerified,
        dataDepartmentComment: dataDepartmentComment,
        foodProvided: foodProvided,
        cup: cup,
        cupMaxBeds: cupMaxBeds,
        cupNA: cupNA,
        slecupNALtrDate: slecupNALtrDate,
        aDPLicCert: aDPLicCert,
        aDPEffDate: aDPEffDate,
        aDPExpDate: aDPExpDate,
        ADPMaxBeds: ADPMaxBeds,
        sTOPBeds: sTOPBeds,
        overorUnderDARSApprovedCountyRate: overorUnderDARSApprovedCountyRate,
        contractComplianceStatusNote: contractComplianceStatusNote,
      };
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {
          setFormSuccess(true);
          setIsNewCBPForm(false);
        }
      }).catch((e) => alert(e));
    }
  };

  const handleCancelPopUp = () => {
    setCancelPopUp(true);
  };

  return (
    <>
      {formLoading ? (
        <ProgressBar />
      ) : (
        <>
          <FormHeading container>
            <FormContentTitle item xs={12} sm={1.5}>
              <BackIcon />
              <PageHeading title='CBP Detail' />
            </FormContentTitle>
            <Grid item xs={12} sm={10.5}>
              <FormInputText
                name='cboName'
                type='text'
                control={control}
                disabled={true}
                label='CBP Name'
                // register={register('cboName', {
                //   onChange: (e) => dispatch(setCboName(e.target.value)),
                // })}
              />
            </Grid>
          </FormHeading>
          {/* <Typography variant='h2'>{`CBP NAME: ${cbpFullName}`}</Typography> */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={3}>
              <FormInputDropdown
                name='organization'
                control={control}
                options={isCBOTrueOrganization}
                organizations={true}
                label='Organization'
                errors={!!errors.organization}
                helperText={errors?.organization?.message}
                register={register('organization', {
                  onChange: (e) => dispatch(setOrganization(e.target.value)),
                })}
              />
              <FormInputDropdown
                name='acceptsCCCMS'
                control={control}
                options={stopYesNoIdOptions}
                label='Accepts CCCMS'
                yesNoIdDropDown={true}
                register={register('acceptsCCCMS', {
                  onChange: (e) => dispatch(setAcceptsCCCMS(e.target.value)),
                })}
              />
              <FormInputText
                name='cbpCode'
                type='text'
                control={control}
                label='CBP Code'
                register={register('cbpCode', {
                  onChange: (e) => dispatch(setCbpCode(e.target.value)),
                })}
              />
              <FormInputDropdown
                name='firstReferralContact'
                control={control}
                options={isFirstReferralContact}
                getIdValue={true}
                label='1st Referral Contact'
                register={register('firstReferralContact', {
                  onChange: (e) =>
                    dispatch(setFirstReferralContact(e.target.value)),
                })}
              />
              <FormInputDropdown
                name='secondReferralContact'
                control={control}
                options={isSecondReferralContact}
                getIdValue={true}
                label='2nd Referral Contact'
                register={register('secondReferralContact', {
                  onChange: (e) =>
                    dispatch(setSecondReferralContact(e.target.value)),
                })}
              />
              <FormInputDropdown
                name='lastVerWk'
                control={control}
                options={cbpFormReferenceData?.weeks}
                getIdValue={true}
                isWeeks={true}
                label='Last Verification Week'
                register={register('lastVerWk', {
                  onChange: (e) => dispatch(setLastVerWk(e.target.value)),
                })}
              />
              <FormInputText
                name='cup'
                type='number'
                minValue={0}
                control={control}
                label='Cup Number'
                register={register('cup', {
                  onChange: (e) => dispatch(setCup(e.target.value)),
                })}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormInputDropdown
                name='modality'
                modalityListProvider={true}
                control={control}
                options={cbpFormReferenceData?.modalities}
                getIdValue={true}
                label='Modality'
                errors={!!errors.modality}
                helperText={errors?.modality?.message}
                register={register('modality', {
                  onChange: (e) => dispatch(setModality(e.target.value)),
                })}
              />
              <FormInputDropdown
                name='enhancedServicesRate'
                control={control}
                options={stopYesNoIdOptions}
                label='Enhanced Services Rate'
                yesNoIdDropDown={true}
                register={register('enhancedServicesRate', {
                  onChange: (e) =>
                    dispatch(setEnhancedServicesRate(e.target.value)),
                })}
              />
              <FormInputText
                name='sTOPBeds'
                type='number'
                minValue={0}
                control={control}
                label='STOP Beds'
                register={register('sTOPBeds', {
                  onChange: (e) =>
                    dispatch(setSTOPBeds(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputDropdown
                name='verificationContact'
                control={control}
                options={isVerificationContact}
                getIdValue={true}
                label='1st Verification Contact'
                register={register('verificationContact', {
                  onChange: (e) =>
                    dispatch(setVerificationContact(e.target.value)),
                })}
              />
              <FormInputDropdown
                name='verificationContact2'
                control={control}
                options={isVerificationContact2}
                getIdValue={true}
                label='2nd Verification Contact'
                register={register('verificationContact2', {
                  onChange: (e) =>
                    dispatch(setVerificationContact2(e.target.value)),
                })}
              />
              <FormInputText
                name='slecupNALtrDate'
                type='date'
                control={control}
                shrink={true}
                label='sle/cup na/ltr Date'
                register={register('slecupNALtrDate', {
                  onChange: (e) => dispatch(setSlecupNALtrDate(e.target.value)),
                })}
              />
              <FormInputText
                name='cupMaxBeds'
                type='number'
                minValue={0}
                control={control}
                label='Cup Max Beds'
                register={register('cupMaxBeds', {
                  onChange: (e) =>
                    dispatch(setCupMaxBeds(Number.parseInt(e.target.value))),
                })}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormInputDropdown
                name='gender'
                control={control}
                options={cbpFormReferenceData?.genders}
                getIdValue={true}
                label='Gender'
                errors={!!errors.gender}
                helperText={errors?.gender?.message}
                register={register('gender', {
                  onChange: (e) => dispatch(setGender(e.target.value)),
                })}
              />
              <FormInputDropdown
                name='blanketPurchaseAgreementDedCapSap'
                control={control}
                options={isSAPTrueOrganization}
                organizations={true}
                label='Blanket'
                register={register('blanketPurchaseAgreementDedCapSap', {
                  onChange: (e) =>
                    dispatch(
                      setBlanketPurchaseAgreementDedCapSap(e.target.value)
                    ),
                })}
              />
              <FormInputText
                name='maxAdmits'
                type='number'
                minValue={0}
                control={control}
                label='Max Admits'
                register={register('maxAdmits', {
                  onChange: (e) =>
                    dispatch(setMaxAdmits(Number.parseInt(e.target.value))),
                })}
              />
              <FormInputDropdown
                name='wcVeificationContact1'
                control={control}
                options={isWCVeificationContact1}
                getIdValue={true}
                label='1st WC Verification Contact'
                register={register('wcVeificationContact1', {
                  onChange: (e) =>
                    dispatch(setWcVeificationContact1(e.target.value)),
                })}
              />
              <FormInputDropdown
                name='wcVeificationContact2'
                control={control}
                options={isWCVeificationContact2}
                getIdValue={true}
                label='2nd WC Verification Contact'
                register={register('wcVeificationContact2', {
                  onChange: (e) =>
                    dispatch(setWcVeificationContact2(e.target.value)),
                })}
              />
              <FormInputText
                name='aDPEffDate'
                type='date'
                control={control}
                shrink={true}
                label='ADP Eff Date'
                register={register('aDPEffDate', {
                  onChange: (e) => dispatch(setADPEffDate(e.target.value)),
                })}
              />
              <FormInputText
                name='aDPLicCert'
                type='number'
                minValue={0}
                control={control}
                label='ADP Lic Cert Number'
                register={register('aDPLicCert', {
                  onChange: (e) => dispatch(setADPLicCert(e.target.value)),
                })}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <FormInputDropdown
                name='accepts290s'
                control={control}
                options={stopYesNoIdOptions}
                label={`Accepts 290's`}
                yesNoIdDropDown={true}
                register={register('accepts290s', {
                  onChange: (e) => dispatch(setAccepts290s(e.target.value)),
                })}
              />
              <FormInputDropdown
                name='foodProvided'
                control={control}
                options={stopYesNoIdOptions}
                label='Food Provided'
                yesNoIdDropDown={true}
                register={register('foodProvided', {
                  onChange: (e) => dispatch(setFoodProvided(e.target.value)),
                })}
              />
              <FormInputDropdown
                name='calOMSContact'
                control={control}
                options={isCalOMSContact}
                getIdValue={true}
                label='CalOms Contact'
                register={register('calOMSContact', {
                  onChange: (e) => dispatch(setCalOMSContact(e.target.value)),
                })}
              />
              <Box style={{ marginBottom: '-2.5px' }}></Box>
              <FormInputDropdown
                name='wcCalOMSContacts1'
                control={control}
                options={isWCCalOMSContacts1}
                getIdValue={true}
                label='1st WC CalOMS Contact'
                register={register('wcCalOMSContacts1', {
                  onChange: (e) =>
                    dispatch(setWcCalOMSContacts1(e.target.value)),
                })}
              />
              <FormInputDropdown
                name='wcCalOMSContact2'
                control={control}
                options={isWCCalOMSContact2}
                getIdValue={true}
                label='2nd WC CalOMS Contact'
                register={register('wcCalOMSContact2', {
                  onChange: (e) =>
                    dispatch(setWcCalOMSContact2(e.target.value)),
                })}
              />
              <FormInputText
                name='aDPExpDate'
                type='date'
                control={control}
                shrink={true}
                label='ADP Exp Date'
                register={register('aDPExpDate', {
                  onChange: (e) => dispatch(setADPExpDate(e.target.value)),
                })}
              />
              <FormInputText
                name='ADPMaxBeds'
                type='number'
                minValue={0}
                control={control}
                label='ADP Max Beds'
                register={register('ADPMaxBeds', {
                  onChange: (e) =>
                    dispatch(setADPMaxBeds(Number.parseInt(e.target.value))),
                })}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormInputText
                name='dataDepartmentComment'
                type='text'
                control={control}
                multiline={true}
                rows={5}
                label='Data Department Comment'
                errors={!!errors.dataDepartmentComment}
                helperText={errors?.dataDepartmentComment?.message}
                register={register('dataDepartmentComment', {
                  onChange: (e) =>
                    dispatch(setDataDepartmentComment(e.target.value)),
                })}
              />
              <Typography variant='h5'>Other Check's</Typography>
              <FormInputMultiCheckbox
                name='sap'
                control={control}
                label='SAP'
                checked={defaultValue?.sap}
                register={register('sap', {
                  onChange: (e) => dispatch(setSap(e.target.value)),
                })}
              />
              <FormInputMultiCheckbox
                name='bPADedCap'
                control={control}
                label='BPA/DedCap'
                checked={defaultValue?.bPADedCap}
                register={register('bPADedCap', {
                  onChange: (e) => dispatch(setBPADedCap(e.target.value)),
                })}
              />
              <FormInputMultiCheckbox
                name='inactive'
                control={control}
                label='Inactive'
                checked={defaultValue?.inactive}
                register={register('inactive', {
                  onChange: (e) => dispatch(setInactive(e.target.value)),
                })}
              />
              <FormInputMultiCheckbox
                name='flagged'
                control={control}
                label='Flagged'
                checked={defaultValue?.flagged}
                register={register('flagged', {
                  onChange: (e) => dispatch(setFlagged(e.target.value)),
                })}
              />
              <FormInputMultiCheckbox
                name='verLock'
                control={control}
                label='Ver Lock'
                checked={defaultValue?.verLock}
                register={register('verLock', {
                  onChange: (e) => dispatch(setVerLock(e.target.value)),
                })}
              />
              <FormInputMultiCheckbox
                name='cupNA'
                control={control}
                label='Cup n/a'
                checked={defaultValue?.cupNA}
                register={register('cupNA', {
                  onChange: (e) => dispatch(setCupNA(e.target.value)),
                })}
              />
              <FormInputMultiCheckbox
                name='currentFYRateSheetReceivedandVerified'
                control={control}
                label='Current FY Rate Sheet Received and Verified'
                checked={defaultValue?.currentFYRateSheetReceivedandVerified}
                register={register('currentFYRateSheetReceivedandVerified', {
                  onChange: (e) =>
                    dispatch(
                      setCurrentFYRateSheetReceivedandVerified(e.target.value)
                    ),
                })}
              />
              <FormInputMultiCheckbox
                name='overorUnderDARSApprovedCountyRate'
                control={control}
                label='Over or Under Dars Approved County Rates'
                checked={defaultValue?.overorUnderDARSApprovedCountyRate}
                register={register('overorUnderDARSApprovedCountyRate', {
                  onChange: (e) =>
                    dispatch(
                      setOverorUnderDARSApprovedCountyRate(e.target.value)
                    ),
                })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormInputText
                name='contractComplianceStatusNote'
                type='text'
                control={control}
                multiline={true}
                rows={5}
                label='Contract Compliance Status Note'
                errors={!!errors.contractComplianceStatusNote}
                helperText={errors?.contractComplianceStatusNote?.message}
                register={register('contractComplianceStatusNote', {
                  onChange: (e) =>
                    dispatch(setContractComplianceStatusNote(e.target.value)),
                })}
              />
              <Typography variant='h5'>
                Treatement level of intensity : Check all that apply
              </Typography>
              <FormInputMultiCheckbox
                name='lowIntensity'
                control={control}
                label='Low Intensity'
                checked={defaultValue?.lowIntensity}
                register={register('lowIntensity', {
                  onChange: (e) => dispatch(setLowIntensity(e.target.value)),
                })}
              />
              <FormInputMultiCheckbox
                name='medIntensity'
                control={control}
                label='Medium Intensity'
                checked={defaultValue?.medIntensity}
                register={register('medIntensity', {
                  onChange: (e) => dispatch(setMedIntensity(e.target.value)),
                })}
              />
              <FormInputMultiCheckbox
                name='highIntensity'
                control={control}
                label='High Intensity'
                checked={defaultValue?.highIntensity}
                register={register('highIntensity', {
                  onChange: (e) => dispatch(setHighIntensity(e.target.value)),
                })}
              />
            </Grid>
          </Grid>
          <ButtonWrapper>
            <CancelButton
              variant='contained'
              //disabled={_.isEmpty(dirtyFields) || !isValid}
              onClick={handleCancelPopUp}
            >
              Cancel
            </CancelButton>
            <SaveButton
              variant='contained'
              //disabled={_.isEmpty(dirtyFields) || !isValid}
              onClick={handleSubmit(onSubmit)}
            >
              Save
            </SaveButton>
          </ButtonWrapper>
          {cbpForm?.newCbpForm ? (
            ''
          ) : (
            <>
              <FullDivider />
              <Box>
                <Accordion
                  expanded={expanded === 'caseManagerPanel'}
                  onChange={handleChange('caseManagerPanel')}
                >
                  <AccordionSummary
                    aria-controls='caseManagerPanel-content'
                    id='caseManagerPanel-header'
                    expandIcon={<ExpandMoreIcon />}
                  >
                    <Typography variant='h5'>Case Manager List</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <CBPCaseManagerList />
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === 'cbpRatesPanel'}
                  onChange={handleChange('cbpRatesPanel')}
                >
                  <AccordionSummary
                    aria-controls='cbpRatesPanel-content'
                    id='cbpRatesPanel-header'
                    expandIcon={<ExpandMoreIcon />}
                  >
                    <Typography variant='h5'>CBP Rates List</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <CbpRates />
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === 'cBPInvoicesPanel'}
                  onChange={handleChange('cBPInvoicesPanel')}
                >
                  <AccordionSummary
                    aria-controls='cBPInvoicesPanel-content'
                    id='cBPInvoicesPanel-header'
                    expandIcon={<ExpandMoreIcon />}
                  >
                    <Typography variant='h5'>CBP Invoices List</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <CBPInvoicesList />
                  </AccordionDetails>
                </Accordion>
              </Box>
            </>
          )}
          <FormSuccess
            formSuccess={formSuccess}
            setFormSuccess={setFormSuccess}
            isNewForm={isNewCBPForm}
          />
          <CancelPopUp
            cancelPopUp={cancelPopUp}
            setCancelPopUp={setCancelPopUp}
          />
        </>
      )}
    </>
  );
};

export default CbpForm;
